import { render, staticRenderFns } from "./FiltersList.vue?vue&type=template&id=2a184b64"
import script from "./FiltersList.vue?vue&type=script&lang=js"
export * from "./FiltersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports